(() => {
'use strict';
function initialize(root) {
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 const $=selector=>root.querySelector(selector);
 const config=JSON.parse($('[data-ab-config]').textContent);
 const grid=$('#abm-product-grid'), count=$('#abm-result-count'), search=$('#abm-search-input'), sort=$('#abm-sort');
 const bank=$('#abm-feature-bank');
 const cards=[...grid.querySelectorAll('[data-product]')];
 const cardMap=new Map(cards.map(card=>[card.dataset.product,card]));
 const features=new Map([...root.querySelectorAll('[data-feature]')].map(feature=>[feature.dataset.feature,feature]));
 const featureKeys={diamonds:'diamond',blue:'turquoise',green:'jade',neutral:'pearl',colour:'earth'};
 let active='all';
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
function setupGalleries(){
  grid.querySelectorAll('.abm-product-gallery').forEach(gallery=>{
    const buttons=[...gallery.parentElement.querySelectorAll('[data-photo]')];
    let pointer=null, suppressClick=false;
    const update=()=>{
      const index=Math.round(gallery.scrollLeft/gallery.clientWidth);
      buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
      [...gallery.children].forEach((slide,i)=>slide.tabIndex=i===index?0:-1);
    };
    gallery.addEventListener('scroll',update,{passive:true});
    gallery.addEventListener('pointerdown',e=>{
      suppressClick=false;
      pointer={id:e.pointerId,x:e.clientX,y:e.clientY,left:gallery.scrollLeft,mouse:e.pointerType==='mouse',drag:false};
    });
    gallery.addEventListener('pointermove',e=>{
      if(!pointer||!pointer.mouse||e.buttons!==1)return;
      const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y;
      if(!pointer.drag&&Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)){
        pointer.drag=true;gallery.setPointerCapture(e.pointerId);gallery.classList.add('abm-dragging');
      }
      if(pointer.drag){e.preventDefault();gallery.scrollLeft=pointer.left-dx;suppressClick=true;}
    });
    const release=e=>{
      if(!pointer)return;
      if(Math.abs(e.clientX-pointer.x)>10)suppressClick=true;
      if(pointer.drag){
        gallery.classList.remove('abm-dragging');
        if(gallery.hasPointerCapture(pointer.id))gallery.releasePointerCapture(pointer.id);
        const delta=e.clientX-pointer.x;
        const current=Math.round(pointer.left/gallery.clientWidth);
        const index=Math.abs(delta)>gallery.clientWidth*.18?current+(delta<0?1:-1):current;
        gallery.scrollTo({left:Math.max(0,Math.min(buttons.length-1,index))*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      pointer=null;
    };
    gallery.addEventListener('pointerup',release);
    gallery.addEventListener('pointercancel',()=>{pointer=null;gallery.classList.remove('abm-dragging');});
    gallery.addEventListener('click',e=>{if(suppressClick){e.preventDefault();suppressClick=false;}},true);
  });
}

 function render() {
   const term=search.value.trim().toLowerCase();
   let list=(active==='all'?cards:(config.orders[active]||[]).map(id=>cardMap.get(String(id))).filter(Boolean)).filter(card=>!term||card.dataset.search.includes(term));
   if(sort.value==='price-asc')list=[...list].sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
   if(sort.value==='price-desc')list=[...list].sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
   const showAllFeatures=active==='all'&&!term&&sort.value==='featured';
   const showCategoryFeature=active!=='all'&&!term;
   const allFeatureOrder=(config.featureOrder||[]).filter(key=>features.has(key));
   const content=[];
   list.forEach((card,i)=>{
     let key=null;
     if(showCategoryFeature&&i===4)key=featureKeys[active];
     if(showAllFeatures&&i>0&&i%4===0)key=allFeatureOrder[i/4-1];
     const feature=features.get(key);
     if(feature){feature.classList.toggle('abm-category-feature',showCategoryFeature);content.push(feature);}
     content.push(card);
   });
   const included=new Set(content);
   [...cards,...features.values()].forEach(node=>{if(!included.has(node))bank.append(node);});
   content.forEach(node=>grid.append(node));
   grid.dataset.category=active;
   count.textContent=(list.length===1?config.countOne:config.countOther).replace('__COUNT__',list.length);
   $('#abm-selection-summary').textContent=(active==='all'&&!term?config.summary:config.summaryFiltered).replace('__COUNT__',list.length);
   $('#abm-empty').hidden=!!list.length;
   const fullSearch=new URL($('#abm-search-form').action);
   fullSearch.searchParams.set('type','product');
   fullSearch.searchParams.set('options[prefix]','last');
   if(term)fullSearch.searchParams.set('q',search.value.trim());
   root.querySelectorAll('[data-ab-full-search]').forEach(link=>{
     link.href=term?fullSearch.href:link.dataset.catalogUrl;
     link.textContent=term?config.searchFull:config.browseAll;
   });
   root.querySelectorAll('[data-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===active)));
 }
 const showCollection=()=>$('#abm-collection').scrollIntoView({behavior:'instant'});
 function filterTo(value){active=value;render();}
 root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{search.value='';filterTo(button.dataset.filter);showCollection();}));
 root.querySelectorAll('button[data-category]').forEach(button=>button.addEventListener('click',()=>{
   search.value='';sort.value='featured';filterTo(button.dataset.category);showCollection();
 }));
 search.addEventListener('input',()=>{active='all';render();});
 sort.addEventListener('change',render);
 $('#abm-clear-search').addEventListener('click',()=>{search.value='';render();search.focus();});
 $('#abm-search-button').addEventListener('click',()=>{$('#abm-search-panel').hidden=false;showCollection();search.focus({preventScroll:true});});
 $('#abm-reset-filters').addEventListener('click',()=>{search.value='';sort.value='featured';filterTo('all');});
 setupGalleries();
 grid.addEventListener('click',event=>{
   const button=event.target.closest('button[data-photo]');
   if(!button||!grid.contains(button))return;
   event.preventDefault();
   const shell=button.closest('.abm-gallery-shell');
   const gallery=shell.querySelector('.abm-product-gallery');
   const index=Number(button.dataset.photo);
   requestAnimationFrame(()=>{
     gallery.scrollTo({left:index*gallery.getBoundingClientRect().width,behavior:'instant'});
     shell.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.photo)===index)));
     [...gallery.children].forEach((slide,i)=>slide.tabIndex=i===index?0:-1);
   });
 },true);
 const storageKey='ab-men-editorial:'+location.pathname;
 try {
   const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');
   if(saved&&performance.getEntriesByType('navigation')[0]?.type==='back_forward'){
     active=saved.active in config.orders?saved.active:'all';search.value=saved.search||'';sort.value=saved.sort||'featured';
     if(search.value)$('#abm-search-panel').hidden=false;
     render();
   }
 } catch {}
 const save=()=>{try{sessionStorage.setItem(storageKey,JSON.stringify({active,search:search.value,sort:sort.value}));}catch{}};
 root.addEventListener('click',save);
 root.addEventListener('change',save);
 root.addEventListener('input',save);
 root.addEventListener('shopify:block:select',event=>{const block=event.target;if(block.closest('#abm-feature-bank')){active='all';search.value='';sort.value='featured';render();}block.scrollIntoView({block:'center',behavior:reduced()?'instant':'smooth'});});
 root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
}
function start(){document.querySelectorAll('[data-ab-editorial]').forEach(initialize);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',start);
})();
